import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import "./theme/tailwind.css";
import "react-day-picker/dist/style.css";
import "./theme/scss/style.scss";
import configureStore from "./data/store/configureStore";
import AppRouter from "./routing/router";
import initSubscriber from "redux-subscriber";
import isEmpty from "lodash/isEmpty";
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';
// import {ErrorPage} from "ui/booking/components/ErrorPages/ErrorPage";
// import { RollbarContext } from '@rollbar/react';

const store = configureStore();
initSubscriber(store);
 
const bookingContainer = document.getElementById("app");
if (bookingContainer !== null) {
    const booking = createRoot(bookingContainer);

    if(!isEmpty(window.ROLLBAR_CONFIG)) {
        booking.render(
            <RollbarProvider config={window.ROLLBAR_CONFIG}>
                {/* ErrorBoundary catches all React errors in the tree below and logs them to Rollbar */}
                <ErrorBoundary>
                    <Provider store={store}>
                        <RouterProvider router={AppRouter} />
                    </Provider>
                </ErrorBoundary>
            </RollbarProvider>
        )
    } else {
        booking.render(<Provider store={store}>
            <RouterProvider router={AppRouter} />
        </Provider>)
    }
}
